import getConfig from 'next/config';

export const {
  CLUSTER,
  ENV,
  sentry_dsn: sentryDsn,
} = getConfig().publicRuntimeConfig;
